var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconDirectorVpCto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.094 8.188h5.25v.656c0 .383.273.656.656.656.355 0 .656-.273.656-.629v-.684h5.25v.657c0 .383.274.656.656.656.356 0 .657-.273.657-.629v-.93c0-.574-.492-1.066-1.067-1.066H9.656v-1.75h1.094a.881.881 0 0 0 .875-.875V1.625A.9.9 0 0 0 10.75.75h-3.5a.881.881 0 0 0-.875.875V4.25c0 .246.082.465.246.629a.866.866 0 0 0 .629.246h1.094v1.75H2.82c-.574 0-1.039.492-1.039 1.066v.903c0 .383.274.656.63.656.327 0 .683-.273.683-.656v-.656zm4.594-4.376v-1.75h2.625v1.75H7.687zm9.187 6.563H14.25a.881.881 0 0 0-.875.875v2.625c0 .492.383.875.875.875h2.625a.881.881 0 0 0 .875-.875V11.25a.9.9 0 0 0-.875-.875zm-.438 3.063h-1.75v-1.75h1.75v1.75zm-6.125-3.063H7.688a.881.881 0 0 0-.875.875v2.625c0 .492.382.875.875.875h2.625a.881.881 0 0 0 .874-.875V11.25a.9.9 0 0 0-.874-.875zm-.437 3.063h-1.75v-1.75h1.75v1.75zM3.75 10.374H1.125a.881.881 0 0 0-.875.875v2.625c0 .492.383.875.875.875H3.75a.881.881 0 0 0 .875-.875V11.25a.9.9 0 0 0-.875-.875zm-.438 3.063h-1.75v-1.75h1.75v1.75z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconDirectorVpCto);
export default __webpack_public_path__ + "static/media/survey-icon-director-vp-cto.2977a69382bad861783832c1f982afb2.svg";
export { ForwardRef as ReactComponent };